'use client';
import { ComponentPropsWithoutRef } from 'react';
import { cn } from '@/shared/lib/cn';
import './mini-banner.scss';

type Props = ComponentPropsWithoutRef<'div'>;
export const MiniBannersGrid = ({ children, ...props }: Props) => {
    return (
        <div {...props} className={cn('mini-banners', 'mini-banners--grid')}>
            {children}
        </div>
    );
};
